<script lang='ts'>
import type { Session } from '../services';
import styler,{ templateStyle } from '../styler';
import Countdown from './Countdown.svelte';
import EventCard from './EventCard.svelte';
import { EventState } from './shared';
// import { Link } from "svelte-navigator";

const ShowAllEventsOnShowOver = true;

export let events: Session[];
export let showScheduleButton;
export let header;
export let sectionTitle;

enum State {
  Loading,
  Upcoming,
  Now,
  ShowEnded,
  ShowEndedWithReplay
}

const sectionTextMapping = {
  [State.Upcoming]: 'NEXT SESSIONS',
  [State.Now]: 'CURRENTLY LIVE SESSIONS',
  [State.ShowEnded]: 'NO UPCOMING SESSIONS',
  [State.ShowEndedWithReplay]: 'PAST EVENTS',
}

let refreshTimer;
let renderedEvents = [];
let state = State.Loading;
let countdownTargetTime;
let sectionText;

function updateSchedule() {
  const now = new Date();
  
  // Note: Events are already sorted
  const nowOrFutureEvents = events.filter(event => now < event.end)
  
  if (nowOrFutureEvents.length === 0) {
    // Show's over

    if (ShowAllEventsOnShowOver) {
      state = State.ShowEndedWithReplay;
      renderedEvents = events.filter(e => e.replayStream);
    } else {
      state = State.ShowEnded;
      renderedEvents = []
    }
    
    refreshTimer?.unsubscribe()
    return;
  }

  // Get events happening now or starting soon
  const nextUpEvents = nowOrFutureEvents.filter(event => event.state === EventState.StartingSoon || event.state === EventState.Live)
  if (nextUpEvents.length > 0) {
    state = State.Now;
    renderedEvents = nextUpEvents;
    return;
  }

  // Upcoming shows that start at the same time
  const first = nowOrFutureEvents.slice(0, 1)[0]
  const startTimestamp = first.start.getTime();
  const upcomingEvents = nowOrFutureEvents.filter(event => event.start.getTime() === startTimestamp)
  
  state = State.Upcoming;
  renderedEvents = upcomingEvents;
  countdownTargetTime = first.start;
}

$: events, updateSchedule()
$: sectionText = sectionTextMapping[state] || ''
</script>

<div class="section-header">{sectionTitle}</div>

<div class="box col vcenter start" use:styler={templateStyle(header)}>
  {#if state === State.Loading}
       <div class="title mb-2">Walking to stage...</div>
  {:else if state === State.Upcoming}
      <div class="title mb-2">THE NEXT SESSION{renderedEvents.length > 1 ? 'S' : ''} START IN:</div>

      <div class="countdown mb-2">
        <span>Live in&hairsp;</span>
        <Countdown endTime={countdownTargetTime} />
      </div>
  {:else if state === State.Now}
      <div class="title mb-2">THE SESSIONS BELOW ARE CURRENTLY LIVE</div>

      <!-- <div class="desc mt-8">Please click the "join" button to join the session in progress.</div> -->
  {:else if state === State.ShowEnded}
      <div class="title mb-2">NO LIVE SESSIONS</div>
      <div class="desc mt-8">The event has ended. Thank you for attending!</div>
  {:else if state === State.ShowEndedWithReplay}
      <div class="title mb-2">LIVE SESSIONS HAVE ENDED</div>
      <div class="desc mt-8">The sessions below are available for replay.</div>
  {/if}

  {#if showScheduleButton}
    <a href="/schedule" class='button secondary' style="margin-top: 8px">
      VIEW FULL SCHEDULE
    </a>
  {/if}
</div>

<div class="section-header">{sectionText}</div>

{#each renderedEvents as event (event.id)}
  <EventCard {...event} />
{/each}

<style lang="scss">
@import '../util';

.box {
  padding: 24px 48px;
  margin-bottom: 32px;
  background-color: var(--primary);
  color: var(--text-primary);
  background-size: cover;
  background-position: center;
  min-height: 182px;

  @include shadow;
}

.title {
  text-transform: uppercase;
  font-size: 40px;
  font-weight: 900;
}

.desc {
  font-size: 16px;
}

.countdown {
  font-size: 24px;
  font-weight: normal;

  @include landscape {
    font-size: 26px;
  }

  @include mobile {
    font-size: 20px;
  }
}
</style>